export default __webpack_public_path__ + "static/media/cocora.c98c423b.png";